interface ModelHouse {
  no: string;
  heading: string;
  name: string;
  imageUrl: string;
  detailUrl: string;
  reserveUrl: string;
}

const modelHouses: ModelHouse[] = [
  {
    no: '01',
    heading: '大空間・大開口の家',
    name: 'アスタ住宅展示場',
    imageUrl:
      'https://static.readdy.ai/image/30f27ef602d0090e19be279ddf894f7d/d355ba8c4aa239b21153119220566948.jpeg',
    detailUrl: 'https://www.giazo.life/hiroshima/?id=1',
    reserveUrl: 'https://www.giazo.life/hiroshima/?id=1#p-model-reserve',
  },
  {
    no: '02',
    heading: '上質が織りなす邸宅',
    name: '東広島ハウジングフェア展示場',
    imageUrl:
      'https://static.readdy.ai/image/30f27ef602d0090e19be279ddf894f7d/0e01bc3675087cc62f199efcdfa0bec0.jpeg',
    detailUrl: 'https://www.giazo.life/higashi-hiroshima/?id=2',
    reserveUrl: 'https://www.giazo.life/higashi-hiroshima/?id=2#p-model-reserve',
  },
  {
    no: '03',
    heading: '品格を纏う暮らし',
    name: '住宅宣言ふくやま広島テレビ展示場',
    imageUrl:
      'https://static.readdy.ai/image/30f27ef602d0090e19be279ddf894f7d/6321a12020a4f822ece781ae975853a9.jpeg',
    detailUrl: 'https://www.giazo.life/fukuyama/?id=3',
    reserveUrl: 'https://www.giazo.life/fukuyama/?id=3#p-model-reserve',
  },
  {
    no: '04',
    heading: '格式ある空間と、上質な広がり',
    name: 'ふれあいホームタウンおのみち',
    imageUrl:
      'https://storage.readdy-site.link/project_files/08d9908a-2395-4ac3-82a1-6049451d0d9d/57deb3f4-c999-489b-bf78-01246c84c60e_compressed_GIAZO.webp',
    detailUrl: 'https://www.giazo.life/onomichi/?id=4',
    reserveUrl: 'https://www.giazo.life/onomichi/?id=4#p-model-reserve',
  },
];

export default function ModelHouseSection() {
  return (
    <section id="model-house" className="relative w-full bg-background-50 py-28 md:py-40">
      <div className="w-full px-6 md:px-16">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20">
          <p className="font-sans text-[12px] tracking-[0.2em] text-foreground-400 mb-6">
            MODEL HOUSE ／ 対象の展示場
          </p>
          <h2
            className="font-heading text-[24px] md:text-[32px] tracking-[0.1em] text-foreground-950 mb-6"
            style={{ fontWeight: 300 }}
          >
            対象モデルハウス4展示場
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-12 md:gap-x-12 md:gap-y-16">
          {modelHouses.map((house) => (
            <div key={house.name} className="flex flex-col">
              {/* Image with NO. label */}
              <div className="relative w-full overflow-hidden">
                <span className="absolute top-3 left-3 z-10 bg-background-50 px-2.5 py-1.5 font-sans text-[12px] tracking-[0.1em] text-foreground-700">
                  NO. {house.no}
                </span>
                <div className="w-full" style={{ aspectRatio: '4/3' }}>
                  <img
                    src={house.imageUrl}
                    alt={house.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <p
                className="mt-5 font-sans text-[13px] tracking-[0.08em] text-foreground-500"
                style={{ fontWeight: 300 }}
              >
                {house.heading}
              </p>
              <h3
                className="mt-1 font-sans text-[16px] md:text-[17px] tracking-[0.06em] text-foreground-950"
                style={{ fontWeight: 400 }}
              >
                {house.name}
              </h3>

              <div className="mt-5 flex flex-col sm:flex-row items-stretch gap-3">
                <a
                  href={house.detailUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 flex-1 border border-foreground-950 px-4 py-3.5 text-[13px] tracking-[0.06em] text-foreground-950 hover:bg-foreground-950 hover:text-background-50 transition-colors duration-500 whitespace-nowrap cursor-pointer"
                >
                  詳細を見る
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </a>
                <a
                  href={house.reserveUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 flex-1 bg-primary-500 px-4 py-3.5 text-[13px] tracking-[0.06em] text-background-50 hover:bg-primary-600 transition-colors duration-500 whitespace-nowrap cursor-pointer"
                >
                  見学予約はこちらから
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}